<template lang="">
  <div class="flex-fill">
    <section id="banner" class="" style="background-image: url('static/img/default/header-aduan.png'); background-size: contain; background-repeat: no-repeat; background-position: top center; ">
      <div class="container py-20">
        <div class="text-center">
          <span class="d-block text-white font-size-h2 font-weight-bolder mb-10">Form Aduan Serikat Karyawan Hutama Karya</span>
        </div>
        <div class="card card-custom rounded-xl">
          <div class="card-body p-15">
            <h3 class="font-weight-bold mb-10">
              <i class="ri-mail-line text-dark font-weight-boldest"></i>
              {{ forms.email }}
            </h3>
            <div>
              <s-input v-model="forms.category_id" :item="{ label: 'Pilih Kategori Aduan', type: 'select', validation: ['required'], ic: '', baseURL: wbsUrl, api: 'no-auth/allegation-categories/dataset', pointer: { label: 'name', code: 'id' } }" />
              <s-input v-model="forms.title" :item="{ label: 'Judul', type: 'text', validation: ['required'], ic: 'form-control-lg', nm: false }" />
              <s-input v-model="forms.description" :item="{ label: 'Deskripsi', type: 'textarea', validation: ['required'], ic: 'form-control-lg', placeholder: 'Konten & Deskripsi' }" />
              <s-input v-model="forms.contact" :item="{ label: 'Nomor / Email yang dapat dihubungi', type: 'text', validation: [], ic: 'form-control-lg', nm: true }" />
              <div class="alert alert-custom px-4 py-2 mt-2 gutter-b" style="background-color: #f3f6f9;" role="alert">
                <div class="alert-icon alert-icon-top">
                  <i class="ri-notification-fill text-secondary"></i>
                </div>
                <div class="alert-text">
                  <p class="mb-0">
                    Kami akan menggunakan kontak ini untuk proses verifikasi data.
                    <br />
                    Gunakan kontak atau email secondary (fake email) untuk menjaga kerahasiaan identitas Anda.
                  </p>
                </div>
              </div>
              <div class="form-group">
                <label>Lampirkan Dokumen (jika ada)</label>
                <multi-upload-wbs :error="[]" :auth="false" v-model="forms.child_data_allegation_attachments" :attr="[{ accept: '.jpg, .jpeg, .png, .pdf' }, { limit: 5 }, { max: 5 }]" />
              </div>
              <div id="g-recaptcha" class="mb-5"></div>
              <button @click="sendFeedback()" :disabled="!captcha || !validForm" class="btn btn-primary btn-lg">
                <i class="ri-mail-send-line"></i>
                <span class="font-size-md font-weight-bolder">Kirim Aduan</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<!-- this.$refs.otpInput.clearInput() -->
<script>
import mode from '@/mode.js'
export default {
  name: 'landing-aduan',
  data () {
    return {
      forms: {
        email: null,
        otp: null,
        category_id: null,
        title: null,
        description: null,
        contact: null,
        child_data_allegation_attachments: []
      },
      captcha: null
    }
  },
  mounted () {
    // <!-- 6LeLrgYlAAAAAGfHpG5y7_j4uB10T2r3-0O3CGn_ -->
    // eslint-disable-next-line no-undef
    grecaptcha.render('g-recaptcha', {
      sitekey: '6LcmigopAAAAAOOR7S4E4APu-02vaLdi5l1SGcQo',
      callback: ($event) => {
        this.captcha = $event
      },
      'expired-callback': ($event) => {
        this.captcha = null
      },
      'error-callback': ($event) => {
        this.captcha = null
      }
    })
    // eslint-disable-next-line no-undef
    // const result = recaptchaCallback()
    // console.log(result)
    // console.log(this.$route.query)
    this.forms = Object.assign({}, this.forms, this.$route.query)
    // this.checkOTP()
  },
  computed: {
    validForm () {
      return Boolean(this.forms.category_id && this.forms.description && this.forms.title)
    },
    wbsUrl () {
      return this.$_config.wbs[mode]
    }
  },
  methods: {
    checkOTP (e) {
      this.$_api
        .fetch('post', this.$_config.wbs[mode] + 'no-auth/create-allegations/verification-otp', { email: this.forms.email, otp: this.forms.otp })
        .then((res) => {
          console.log('masih')
        })
        .catch((err) => {
          console.log('kadaluarsa')
          this.$_alert.error(err)
        })
    },
    sendFeedback () {
      if (this.validForm) {
        this.$_api
          .fetch('post', this.$_config.wbs[mode] + 'no-auth/allegations/create', this.forms)
          .then((res) => {
            this.$_alert.confirm('Form Aduan Terkirim', res.message, 'Tutup', null, 'success', false).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({
                  name: 'pengaduan-landing'
                })
              } else {
                this.$router.push({
                  name: 'pengaduan-landing'
                })
              }
            })
          })
          .catch((err) => {
            this.$_alert.error(err)
          })
      }
    }
  }
}
</script>
<style lang="">
  .otp-input {
    font-size: 2rem;
    width: 50px;
    padding: 1rem 0.57rem;
    text-align: center;
    margin-right: 10px;
    border-radius: 8px;
    border: 1px solid #eeeeee;
  }
  .otp-input::-webkit-inner-spin-button,
  .otp-input::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .otp-input:focus-visible {
    outline: #ddf2fa solid 0.5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/landing-page/isi-aduan.vue